import React, { useState, useEffect } from "react";

import { Grid, Tooltip, Typography, makeStyles, Paper } from "@material-ui/core";
import { CourseDetail, SummaryItem } from "../../types/course";
import { useSpring, config, animated } from "react-spring";
import { FaQuestion, FaHourglassHalf, FaLocationArrow, FaCalendarDay, FaCheck, FaClock, FaCalendar, FaFile, FaTimes, FaInfo, FaGraduationCap, FaUserCheck, FaEuroSign, FaTag, FaUserTimes, FaUser, FaStar } from "react-icons/fa";
import { withRouter, RouteComponentProps } from "react-router";
import { IconOption, getIconOptionByValue } from "../../types/iconSelection";
import { buildCourseDetailItems } from "../../helperfunctions/courseDetailItems";

interface SummaryProps {
    role?: string
    pathname?: string
}

const useStyles = makeStyles({
    infoWrapper: {
        display: "flex",
        flexFlow: "column",
        marginTop: "1em",
        height: "100%",
    },
    info: {
        width: "100%",
        padding: "1em",
        backgroundColor: "#EDEDED"
    },
    icon: {
        fontSize: "20pt"
    }
})

export const getIcon = (name: string, icon?: IconOption) => {
    if (icon) {
        return getIconOptionByValue(icon).label;
    }

    switch (name) {
        case "Huiswerkbegeleiding":
            return (<FaUser />);
        case "Prijs":
        case "Prijs per cursist":
        case "Prijs per cursist bij meer dan 10 cursisten":
            return (<FaEuroSign />);
        case "Vaste prijs":
            return (<FaTag />);
        case "Locatie":
        case "Plaats":
        case "Locaties":
            return (<FaLocationArrow />);
        case "Toets":
            return (<FaFile />);
        case "Les data":
        case "Frequentie":
            return (<FaCalendar />);
        case "Cursus lengte":
            return (<FaClock />);
        case "Examen datum":
        case "Datum afgerond":
        case "Inschrijfdatum":
            return (<FaCalendarDay />);
        case "Certificaat":
        case "Cijfer":
        case "Proefexamen cijfer":
        case "Theorie cijfer":
        case "Coachen & Begeleiden cijfer":
        case "Portfolio cijfer":
            return (<FaGraduationCap />);
        case "BTW":
            return (<FaEuroSign />);
        case "Aanwezig bij examen":
        case "Geslaagd":
            return (<FaCheck />);
        case "Afgewezen":
        case "Afwezig bij examen":
            return (<FaTimes />);
        case "Naam":
        case "Cursussen":
            return (<FaInfo />);
        case "Aanwezigheid":
            return (<FaUserCheck />)
        case "Rating":
            return (<FaStar />)
        case "Afwezig":
            return (<FaUserTimes />)
        case "Status":
            return (<FaHourglassHalf />)
        default:
            return (<FaQuestion />);
    }
}

export const Summary = ({ name, variable, icon }: SummaryItem & SummaryProps) => {
    return (
        <Grid item xs={12} md={12} lg={12} >
            <Grid container spacing={2}>
                <Tooltip title={name} placement="bottom">
                    <Grid item xs={2} className="center-v">
                        {getIcon(name, icon)}
                    </Grid>
                </Tooltip>
                <Grid item xs={10}>
                    {Array.isArray(variable) ?
                        variable && variable.map((d, i) => {
                            if (d) return (
                                <Grid key={i} container>
                                    <Grid item xs={6}>
                                        <Typography variant="body1" className="course-second-column" >{d}</Typography>
                                    </Grid>
                                </Grid>
                            );
                            return null;
                        })
                        : <Typography variant="body1" className="course-second-column">{variable}</Typography>}
                </Grid>
            </Grid>
        </Grid>
    )
}

interface CourseDetailItemProps {
    courseDetail: CourseDetail;
    role: string;
}

const CourseDetailItem = ({ courseDetail, role, location }: CourseDetailItemProps & RouteComponentProps) => {
    const classes = useStyles()
    const [reset, setReset] = useState(false)
    const [register, setRegister] = useState(false)

    useEffect(() => {
        setReset(true)
        location.pathname.includes("inschrijven") ? setRegister(true) : setRegister(false)
        setTimeout(() => {
            setReset(false)
        }, 500);
    }, [courseDetail, location])

    const summaryItems: SummaryItem[] = buildCourseDetailItems(courseDetail, { role, register });

    const animatedProps = useSpring({
        from: { opacity: 0, transform: "translateX(-1rem)", width: "100%" },
        to: { opacity: 1, transform: "translateX(0rem)", width: "100%" },
        reset: reset,
        reverse: reset,
        config: config.stiff
    })

    return (
        <Grid>
            <Typography variant="overline">DETAILS</Typography>
            <Paper className={classes.info}>
                <Grid container className="course-data-container">
                    {!summaryItems || summaryItems.length === 0 ?
                        <Typography>Selecteer een cursus</Typography>
                        :
                        <animated.div style={!register ? animatedProps : { width: "100%" }}>
                            {summaryItems && summaryItems.map((summaryItem, index) => {
                                return <Summary name={summaryItem.name} variable={summaryItem.variable} key={index} icon={summaryItem.icon} />
                            })}
                        </animated.div>
                    }
                </Grid>
            </Paper>
        </Grid>
    )
}

export default withRouter(CourseDetailItem);
